/*
 * Extras del carrito lateral:
 * 1) Packs plegables: «Contiene N artículos» con flecha; abre y pliega animando la altura.
 * 2) Barra de envío gratis: pide a la app (/apps/hm-menus/shipping) desde qué importe es gratis el envío al país
 *    del visitante y pinta cuánto falta, con la barra animada.
 * El carrito se vuelve a pintar entero al cambiar, así que todo se inicia por delegación y con un observador.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- 1) Packs plegables ---- */
  var DURATION = 300;

  function panelOf(details) {
    return details.querySelector('.hm-cart-bundle__panel');
  }

  function animate(details, opening) {
    var panel = panelOf(details);
    if (!panel || reduce.matches || !panel.animate) {
      details.open = opening;
      return;
    }
    if (panel._hmAnim) {
      panel._hmAnim.cancel();
      panel._hmAnim = null;
    }
    if (opening) details.open = true;
    var height = panel.offsetHeight;
    panel.style.overflow = 'hidden';
    details.classList.toggle('is-closing', !opening);
    var frames = opening
      ? [{ height: '0px', opacity: 0 }, { height: height + 'px', opacity: 1 }]
      : [{ height: height + 'px', opacity: 1 }, { height: '0px', opacity: 0 }];
    var anim = panel.animate(frames, { duration: DURATION, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
    panel._hmAnim = anim;
    anim.onfinish = function () {
      if (panel._hmAnim !== anim) return;
      panel._hmAnim = null;
      panel.style.overflow = '';
      details.classList.remove('is-closing');
      if (!opening) details.open = false;
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.hm-cart-bundle__summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    event.preventDefault();
    var closing = details.classList.contains('is-closing');
    animate(details, closing || !details.open);
  });

  /* ---- 2) Barra de envío gratis ---- */
  var lastPercent = 0;

  function fallback(el, country) {
    var cents = Number(el.getAttribute('data-fallback-cents')) || 0;
    var only = (el.getAttribute('data-fallback-country') || '').toUpperCase();
    if (!cents || (only && only !== String(country).toUpperCase())) return { cents: 0, currency: '' };
    return { cents: cents, currency: el.getAttribute('data-currency') || '' };
  }

  function threshold(el) {
    var country = el.getAttribute('data-country') || '';
    var market = el.getAttribute('data-market') || '';
    var key = 'hm_free_' + country + '_' + market;
    try {
      var cached = window.sessionStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}
    var url = el.getAttribute('data-url') + '?country=' + encodeURIComponent(country) + '&market=' + encodeURIComponent(market);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        // La app no responde (o aún no tiene permiso para leer las tarifas): se usa el importe de respaldo
        // del tema, solo para su país, y no se guarda para volver a preguntar en cuanto la app conteste.
        if (!data) return fallback(el, country);
        var value = data.freeFromCents > 0 ? { cents: data.freeFromCents, currency: data.currency || '' } : { cents: 0, currency: '' };
        try {
          window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {}
        return value;
      })
      .catch(function () {
        return fallback(el, country);
      });
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function initFree(el) {
    if (el.getAttribute('data-hm-ready') === '1') return;
    el.setAttribute('data-hm-ready', '1');
    var total = Number(el.getAttribute('data-total')) || 0;
    var currency = el.getAttribute('data-currency') || '';
    var locale = el.getAttribute('data-locale') || 'es';
    var text = el.querySelector('.hm-freeship__text');
    var fill = el.querySelector('.hm-freeship__fill');
    var track = el.querySelector('.hm-freeship__track');
    if (!text || !fill) return;
    threshold(el)
      .then(function (limit) {
        // Sin envío gratis configurado para ese país, o en otra moneda que la de la tienda: no se enseña nada.
        if (!limit || !limit.cents || (limit.currency && currency && limit.currency !== currency)) return;
        var left = Math.max(0, limit.cents - total);
        var percent = Math.min(100, Math.round((total / limit.cents) * 100));
        var reached = left === 0;
        text.textContent = reached
          ? el.getAttribute('data-t-reached')
          : (el.getAttribute('data-t-remaining') || '').replace('[[amount]]', money(left, limit.currency || currency, locale));
        el.classList.toggle('is-reached', reached);
        if (track) track.setAttribute('aria-valuenow', String(percent));
        fill.style.width = lastPercent + '%';
        el.hidden = false;
        // Arranca desde el porcentaje anterior para que la barra crezca (o baje) en lugar de reiniciarse.
        void fill.offsetWidth;
        window.requestAnimationFrame(function () {
          fill.style.width = percent + '%';
        });
        lastPercent = percent;
      })
      .catch(function () {});
  }

  var pending = false;
  function scan() {
    document.querySelectorAll('[data-hm-freeship]').forEach(initFree);
  }

  function boot() {
    scan();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          scan();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
